// Calendar.js

import React, { useState } from 'react';
import './calendarForAskingDoubt.css';
import Grid from '@mui/material/Unstable_Grid2';
import Avatar from '@mui/material/Avatar';
import { FaArrowLeft } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

const today = dayjs();

function CalendarForAskingDoubt(props) {
  const weekdayNames = [['Monday','19'], ['Tueday','20'], ['Wednesday','21'], ['Thursday','22'], ['Friday','23'], ['Saturday','24'], ['Sunday','25']];
  const weekdayDates = ['19', '20', '21', '22', '23', '24', '25'];

  var multiplesOf7 = Array.from({ length: 101 }, (_, index) => index * 7);
  const multiplesOf4 = Array.from({ length: 177 }, (_, index) => index * 4);

  // Create time slots (24 hours * 60 minutes / 15 minutes)
  /*
  const timeSlots = Array.from({ length: 24 * 60 / 15 }, (_, index) => {
    const hours = Math.floor(index * 15 / 60);
    const minutes = (index * 15) % 60;
    const time = new Date(selectedDate);
    time.setHours(hours, minutes);
    return time;    //Time in 24 hour format I guess.
  });*/

  /*
  function displayCalendarImage(){
    return(
      <div>
        <img src='/images/calendar.png'></img>
      </div>
    );
  }*/

  return(
    <div className='cfad_main_div'>
      <div className='cfad_category_div'>
        <FaArrowLeft className='cfad_arrow_size'/>
        <div className='cfad_categories'>Physics</div>
        <div className='cfad_categories'>French</div>
        <div className='cfad_categories'>Guitar</div>
        <div className='cfad_categories'>Mechanical Engineering</div>
        <div className='cfad_categories'>Medicine</div>
        <div className='cfad_categories'>Law</div>
        <FaArrowRight className='cfad_arrow_size'/>
      </div>
      <div className='cfad_calendar_top_dash_div'>
        Feb 2024 {`>`}
        <img className="cfad_calendar_img_show" src='/images/calendar.png'></img>
      </div>
      <Grid container spacing={0} className='cfad_calendar_main_grid'>  {/*Contains up-and-down child grids.*/}
        <Grid container xs={12} columns={7} className='cfad_calendar_upper_section_grid'>
          {weekdayNames.map(function(day, index){
            return(
              <Grid key={index} id={index} xs={1} className='cfad_calendar_upper_section_day_panel_grid'>
                <div className='cfad_calendar_upper_section_day_panel_div'> 
                  <p className='cfad_weekday_name'>{day[0]}</p>
                  <span className='cfad_weekday_date'>{day[1]}</span>                 
                </div>
              </Grid>
            );
          })}
        </Grid>
        <Grid container xs={12} columns={7} className='cfad_calendar_lower_section_grid'>
          {Array.from({ length: 707 }, (_, index) => (
            <Grid xs={1} className='cfad_calendar_lower_section_panel_grid'>
              <div key={index} className='cfad_calendar_lower_section_panel_div'>
                {/*(multiplesOf7.includes(index)? (<div className='cfad_timeSlots'>Q</div>): null)*/}
                {([67,19,87].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="Paul" src='/images/paul.jpg'/><p className='cfad_person_name'>Paul Sebastian</p></div>): null}
                {([10,25,52].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="Urumi" src='/images/urumi.png'/><p className='cfad_person_name'>Hormis C</p></div>): null}
                {([62,130,200].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className='cfad_person_name'>Andrej K</p></div>): null}
                {([235,213,279].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="David" src='/images/david.jpeg'/><p className='cfad_person_name'>David Kipping</p></div>): null}
                {([242,194,262].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="Kevin" src='/images/kevin_systrom.jpg'/><p className='cfad_person_name'>Kevin Systrom</p></div>): null}
                {([160,173,143].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="Paul" src='/images/paul.jpg'/><p className='cfad_person_name'>Paul Sebastian</p></div>): null}
                {([312,325,355].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="Andrej" src='/images/andrej_karpathy.jpg'/><p className='cfad_person_name'>Andrej K</p></div>): null}
                {([31,13,75].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="Urumi" src='/images/urumi.png'/><p className='cfad_person_name'>Hormis C</p></div>): null}
                {([605,705,54].includes(index))  ? (<div><Avatar className="cfad_avatar_class" alt="David" src='/images/david.jpeg'/><p className='cfad_person_name'>David Kipping</p></div>): null}

                {/*<Avatar className="cfad_avatar_class" alt="Paul" src='/images/paul.jpg'/>
                <p className='cfad_name'>Paul Sebastian</p>*/}
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </div>
  );
}

export default CalendarForAskingDoubt;


//-------------------------------------------

/*timeSlots[index]*/


{/*
<div className='cfad_calendar_top_dash_div'>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DateCalendar defaultValue={today} disableFuture />
  </LocalizationProvider>
</div>*/}



//-------------------------------------------

/*
import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useTable } from 'react-table';
//import 'react-table/react-table.css';
//import './BookingSystem.css'; // Add your own styling

const BookingSystem = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Create time slots (24 hours * 60 minutes / 15 minutes)
  const timeSlots = Array.from({ length: 24 * 60 / 15 }, (_, index) => {
    const hours = Math.floor(index * 15 / 60);
    const minutes = (index * 15) % 60;
    const time = new Date(selectedDate);
    time.setHours(hours, minutes);
    return time;    //Time in 24 hour format I guess.
  });

  // Create table columns
  const columns = [
    { Header: 'Time', accessor: 'time' },
    { Header: 'Sunday', accessor: 'sunday' },
    { Header: 'Monday', accessor: 'monday' },
    { Header: 'Tuesday', accessor: 'tuesday' },
    { Header: 'Wednesday', accessor: 'wednesday' },
    { Header: 'Thursday', accessor: 'thursday' },
    { Header: 'Friday', accessor: 'friday' },
    { Header: 'Saturday', accessor: 'saturday' },
  ];

  // Create table data
  const data = timeSlots.map((time) => ({
    time: time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    sunday: 'Book',
    monday: 'Book',
    tuesday: 'Book',
    wednesday: 'Book',
    thursday: 'Book',
    friday: 'Book',
    saturday: 'Book',
  }));

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data });

  const handleDateChange = (newDate) => {
    // -----------
  };

  return (
    <div className="booking-system-container">
      <div className="calendar-container">
        <Calendar onChange={handleDateChange} value={selectedDate} />
      </div>
      <div className="table-container">
        <table {...getTableProps()} className="booking-table">
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookingSystem;*/

